module.exports = __webpack_public_path__ + "img/en.269666d5.svg";